import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const LargeLaboratoryTubeIcon = createIcon({
  displayName: 'LargeLaboratoryTubeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M14,6v4.172c0,0.53 0.211,1.039 0.586,1.414l4.828,4.828c0.375,0.375 0.586,0.884 0.586,1.414v1.172c0,1.105 -0.895,2 -2,2h-12c-1.105,0 -2,-0.895 -2,-2v-1.172c0,-0.53 0.211,-1.039 0.586,-1.414l4.828,-4.828c0.375,-0.375 0.586,-0.884 0.586,-1.414v-4.172"></path>
        <path
          strokeWidth="1.6599"
          d="M10,3h4c0.552,0 1,0.448 1,1v1c0,0.552 -0.448,1 -1,1h-4c-0.552,0 -1,-0.448 -1,-1v-1c0,-0.552 0.448,-1 1,-1Z"
        ></path>
        <path d="M4.18,17h15.64"></path>
        <path d="M9.82,11h4.36"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const LargeLaboratoryTube: FC<IconProps> = (props) => {
  return <CustomIcon as={LargeLaboratoryTubeIcon} {...props} />
}

export default memo(LargeLaboratoryTube)
